import { useEffect, useState } from "react";
import { HomeSlider } from "../../../../types/HomeSlider";
import './Sliders.scss'
import { mediaUrl } from "../../../../helper/Api";
interface SlidersProps {
  sliders: HomeSlider[];
  onAdd: () => void;
  onRemove: (id: string) => void;
  onUpdate: (slider: HomeSlider) => void;
  updateSlider: (homeSlider : HomeSlider,desktop : File | null,mobile : File | null) => void;
}

export default function Sliders({ sliders, onAdd, onRemove, onUpdate, updateSlider }: SlidersProps) {
  //effects
  const [desktopImages, setDesktopImages] = useState<Record<string, File>>({});
  const [mobileImages, setMobileImages] = useState<Record<string, File>>({});

  //actions
  const handleImageUpload = (slider: HomeSlider, type: 'desktop' | 'mobile') => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
  
    input.onchange = (e) => {
      const files = (e.target as HTMLInputElement).files;
      if (files && files.length > 0) {
        const file = files[0];
        if (type === 'desktop') {
          setDesktopImages(prev => ({ ...prev, [slider.id]: file }));
        } else {
          setMobileImages(prev => ({ ...prev, [slider.id]: file }));
        }
      }
    };
  
    input.click();
  };

  const save = (homeSlider : HomeSlider) => {
    updateSlider(homeSlider,desktopImages[homeSlider.id],mobileImages[homeSlider.id])
  }

  //Effects
  useEffect(() => {
    //avoid memory leaks
    return () => {
      Object.values(desktopImages).forEach(file => URL.revokeObjectURL(URL.createObjectURL(file)));
      Object.values(mobileImages).forEach(file => URL.revokeObjectURL(URL.createObjectURL(file)));
    };
  }, []);

  return (
    <div className="slider-wrap">
      <div className="slider-actions">
        <button className="add-btn" onClick={onAdd}>+ Add Slider</button>
      </div>
      
      <div className="sliders-grid">
        {sliders.map((slider) =>{ 
           const desktopFile = desktopImages[slider?.id];
           const mobileFile = mobileImages[slider?.id];
           const desktopPreview = desktopFile ? URL.createObjectURL(desktopFile) : slider?.desktop;
           const mobilePreview = mobileFile ? URL.createObjectURL(mobileFile) : slider?.mobile;
          return (
          <div key={slider?.id} className="slider-card">
            <div className="sliderActions">
                <button 
                className="save-btn"
                onClick={() => save(slider)}
              >
                Save
              </button>
              <input
                type="number"
                value={slider?.index || 0}
                onChange={(e) => onUpdate({...slider, index: Number(e.target.value)})}
                placeholder="Enter destination URL"
                className="index-input"
              />
              <button 
                className="remove-btn"
                onClick={() => onRemove(slider.id)}
              >
                ×
              </button>
            </div>
            {/* Desktop Image */}
            <div 
              className="image-upload desktop"
              onClick={() => handleImageUpload(slider, 'desktop')}
            >
              {desktopPreview ? (
                <>
                  <img src={mediaUrl(desktopPreview)} alt="Desktop version" />
                  <span className="hover-text">Change desktop image</span>
                </>
              ) : (
                <span>Upload desktop image</span>
              )}
            </div>
            
            {/* Mobile Image */}
            <div 
              className="image-upload mobile"
              onClick={() => handleImageUpload(slider, 'mobile')}
            >
              {mobilePreview ? (
                <>
                  <img src={mediaUrl(mobilePreview)} alt="Mobile version" />
                  <span className="hover-text">Change mobile image</span>
                </>
              ) : (
                <span>Upload mobile image</span>
              )}
            </div>
            
            {/* URL Input */}
            <input
              type="text"
              value={slider?.url || ''}
              onChange={(e) => onUpdate({...slider, url: e.target.value})}
              placeholder="Enter destination URL"
              className="url-input"
            />
          </div>
        )})}
      </div>
    </div>
  );
}